@if(isManualPrint && !isShowPreview && !isPrintReceipt){
<div class="overlay">
    &nbsp;
</div>
<div class="{{localService.selectedLanguageCode}} toast-box-wrapper center-full"
    *ngIf="localService.languageContent && localService.languageContent.printer">
    <ngb-toast [header]="localService.languageContent.printer.manual_print" [autohide]="false" (hidden)="onAction(1)">
        <div style="height: calc(100vh - 200px);">
            <div class="custom_rows_body" style="height: calc(100vh - 320px);">
                <div class="row styled_row" *ngFor="let item of manualPrinters;index as i">
                    <div class="col-8">
                        <div class="wrap-div">
                            <label style="font-weight: normal; margin-left: 15px;top: 5px;position: relative;"
                                *ngIf="manualPrinters.length > 1">
                                <input type="checkbox" [(ngModel)]="item.isMerge"
                                    (change)="onSetMergeOrder(item.key)" />
                                <span class="normal_color">&nbsp;</span>
                            </label>
                            <input type="number" style="width: 30px;" *ngIf="manualPrinters.length > 1" placeholder="0"
                                [(ngModel)]="item.mergeOrder" />
                            <button class="button_icon button_icon_color icon_adjust"
                                (click)="onPreview(item.selectedValueKey)">
                                preview
                            </button>
                            <span class="en">#{{i < 9 ? '0' : '' }}{{i+1}}.</span>
                                    <span class="larger">{{item.value}}</span>
                        </div>
                    </div>
                    <div class="col-4 vertical-content" style="text-align: center;">
                        <button style="margin: 5px;" class="btn btn-primary"
                            (click)="onBrowserPrint(item.selectedValueKey)">
                            <i class="material-icons" style="color: white;top: 5px;position: relative;">print</i>
                            <span>{{localService.languageContent.printer.print}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="row" class="row freeze_height">
                    <div class="col-12" style="text-align: left;">
                        <app-label
                            [Text]="localService.languageContent.printer.merge_preview + '&' + localService.languageContent.printer.merge_print" />
                    </div>
                </div>
                <div class="row" class="row freeze_height">
                    <div class="col-4">
                        <i class="material-icons" style="top: 5px;position: relative;" title="Merge Gap">expand</i>
                        <input type="number" style="width: calc(100% - 35px);" [(ngModel)]="mergeGap" />
                    </div>
                    <div class="col-4" style="text-align: center;">
                        <button class="btn btn-primary" (click)="onMergePreview()">
                            <i class="material-icons" style="color: white;top: 5px;position: relative;">preview</i>
                            <span>{{localService.languageContent.printer.preview}}</span>
                        </button>
                    </div>
                    <div class="col-4" style="text-align: center;">
                        <button class="btn btn-primary" (click)="onMergePreview(true)">
                            <i class="material-icons" style="color: white;top: 5px;position: relative;">print</i>
                            <span>{{localService.languageContent.printer.print}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ngb-toast>
</div>
}
<div class="overlay" *ngIf="isShowPreview && printContent">
    &nbsp;
</div>
<div *ngIf="isShowPreview && printContent" class="preview-window">
    <app-receipt-view [printContent]="printContent" [isPreview]="true" (onClose)="isShowPreview = false"
        (onPrinted)="isShowPreview = false" />
</div>
<app-print *ngIf="isPrintReceipt" [fileName]="FileName" [content]="printContent" (onPrinted)="onPrintedReceipt()"
    [printLanguageCode]="printingLanguageId">
</app-print>